import React, { Component } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import swal from 'sweetalert';
import PageContentLayout from 'components/PageContentLayout';
import AddNewPartnerModal from 'components/addpartnermodal';
import { showLoader, showMessage, handleHTTPError } from 'store/actions';
import { retrievePartners, blockPartner, activePartner } from 'apis';
import { Constants } from 'utils/constants';
import classNames from 'classnames';

class PartnerList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            partners: [],
            isOpenAddModal: false,
        };
    }

    componentDidMount = () => {
        this.fetchPartners();
    };

    fetchPartners = async () => {
        try {
            const { data } = await retrievePartners();
            this.setState({ partners: data });
        } catch (error) {
            this.props.handleHTTPError(error);
        }
    };

    block = async (partner) => {
        let ok = await swal({
            title: 'Confirm',
            text: 'Do you want to block this partner?\n Are you sure?',
            icon: 'warning',
            buttons: true,
            dangerMode: true,
        });
        if (!ok) return;
        try {
            this.props.showLoader(true);
            const params = { _id: partner._id };
            const { data } = await blockPartner(params);
            this.props.showMessage({
                show: true,
                message: { type: 'success', text: `${partner.name} has been blocked` },
            });
            const index = this.state.partners.findIndex((x) => x._id === partner._id);
            const newPartners = [...this.state.partners];
            newPartners.splice(index, 1, data);
            this.setState({ partners: newPartners });
        } catch (error) {
            this.props.handleHTTPError(error);
        } finally {
            this.props.showLoader(false);
        }
    };

    active = async (partner) => {
        let ok = await swal({
            title: 'Confirm',
            text: 'Do you want to active this partner?\n Are you sure?',
            icon: 'warning',
            buttons: true,
            dangerMode: true,
        });
        if (!ok) return;
        try {
            this.props.showLoader(true);
            const params = { _id: partner._id };
            const { data } = await activePartner(params);
            this.props.showMessage({
                show: true,
                message: { type: 'success', text: `${partner.name} has been activated` },
            });
            const index = this.state.partners.findIndex((x) => x._id === partner._id);
            const newPartners = [...this.state.partners];
            newPartners.splice(index, 1, data);
            this.setState({ partners: newPartners });
        } catch (error) {
            this.props.handleHTTPError(error);
        } finally {
            this.props.showLoader(false);
        }
    };

    toggleAddModal = () => {
        this.setState({ isOpenAddModal: !this.state.isOpenAddModal });
    };

    render() {
        const generateBody = () => {
            return this.state.partners.map((partner, index) => {
                return (
                    <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{partner.name}</td>
                        <td>{partner.email}</td>
                        <td>{partner.phoneNumber}</td>
                        <td
                            className={classNames(
                                'text-uppercase',
                                partner.status === Constants.ACCOUNT_STATUS.ACTIVE ? 'text-primary' : 'text-secondary',
                            )}
                        >
                            {partner.status}
                        </td>
                        <td>
                            <div className="d-flex justify-content-around">
                                <div
                                    className="text-primary pointer"
                                    onClick={() => {
                                        this.props.history.push(`${this.props.match.url}/${partner._id}`);
                                    }}
                                >
                                    <FontAwesomeIcon icon="pen" />
                                    &nbsp;&nbsp;Edit
                                </div>
                                <div
                                    className={classNames(
                                        'pointer',
                                        partner.status === Constants.ACCOUNT_STATUS.ACTIVE
                                            ? 'text-secondary'
                                            : 'text-primary',
                                    )}
                                    onClick={() => {
                                        if (partner.status === Constants.ACCOUNT_STATUS.ACTIVE) this.block(partner);
                                        else this.active(partner);
                                    }}
                                >
                                    {partner.status === Constants.ACCOUNT_STATUS.ACTIVE ? (
                                        <>
                                            <FontAwesomeIcon icon="ban" />
                                            &nbsp;&nbsp;Block
                                        </>
                                    ) : (
                                        <>
                                            <FontAwesomeIcon icon="check" />
                                            &nbsp;&nbsp;Active
                                        </>
                                    )}
                                </div>
                            </div>
                        </td>
                    </tr>
                );
            });
        };

        return (
            <PageContentLayout
                header={
                    <div className="d-flex justify-content-between align-items-center">
                        <h1 className="font-weight-bold">Partners</h1>
                        <Button color="secondary" onClick={this.toggleAddModal}>
                            <FontAwesomeIcon icon="plus" className="mr-2" />
                            Add New
                        </Button>
                    </div>
                }
            >
                <table className="table table-bordered club-list-table">
                    <thead className="bg-primary text-white">
                        <tr>
                            <th>No</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone Number</th>
                            <th>Status</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.partners.length === 0 && (
                            <tr>
                                <td colSpan="6" className="text-danger text-center">
                                    No Data
                                </td>
                            </tr>
                        )}
                        {generateBody()}
                    </tbody>
                </table>
                <AddNewPartnerModal
                    isOpen={this.state.isOpenAddModal}
                    toggle={this.toggleAddModal}
                    callback={this.fetchPartners}
                />
            </PageContentLayout>
        );
    }
}

export default withRouter(
    connect(null, {
        showLoader,
        showMessage,
        handleHTTPError,
    })(PartnerList),
);
